/* === JUSTFISHING: product cards + Judge.me review area === */


/* =========================================================
 * 1) REMOVE FORCED ?variant= FROM UNTOUCHED PRODUCT CARDS
 * ========================================================= */
(function () {
  'use strict';

  function cleanVariantUrl(raw) {
    try {
      var url = new URL(raw, location.origin);

      if (!url.searchParams.has('variant')) {
        return null;
      }

      url.searchParams.delete('variant');

      return (
        url.pathname +
        (url.search || '') +
        (url.hash || '')
      );
    } catch (e) {
      return null;
    }
  }


  function scrubCard(card) {
    var swatches =
      card.querySelector(
        '.product-card__swatch-list'
      );

    if (!swatches) {
      return;
    }

    if (
      swatches.querySelector(
        'input[type="radio"]:checked'
      )
    ) {
      return;
    }


    card
      .querySelectorAll(
        'a[href*="/products/"][href*="variant="]'
      )
      .forEach(
        function (link) {
          var clean =
            cleanVariantUrl(
              link.href
            );

          if (
            clean !== null &&
            link.getAttribute('href') !== clean
          ) {
            link.setAttribute(
              'href',
              clean
            );
          }
        }
      );


    var quickBuy =
      card.querySelector(
        'quick-buy-modal[product-url*="variant="]'
      );

    if (quickBuy) {
      var current =
        quickBuy.getAttribute(
          'product-url'
        );

      var cleanQuickBuy =
        cleanVariantUrl(
          current
        );

      if (
        cleanQuickBuy !== null &&
        current !== cleanQuickBuy
      ) {
        quickBuy.setAttribute(
          'product-url',
          cleanQuickBuy
        );
      }
    }
  }


  var attached =
    new WeakSet();


  function processCard(card) {
    scrubCard(card);

    if (
      attached.has(card)
    ) {
      return;
    }

    attached.add(card);

    new MutationObserver(
      function () {
        scrubCard(card);
      }
    ).observe(
      card,
      {
        attributes: true,
        subtree: true,
        attributeFilter: [
          'href',
          'product-url'
        ]
      }
    );
  }


  function walk(root) {
    if (
      !root ||
      root.nodeType !== 1
    ) {
      return;
    }

    if (
      root.matches &&
      root.matches(
        'product-card'
      )
    ) {
      processCard(root);
    }

    if (
      root.querySelectorAll
    ) {
      root
        .querySelectorAll(
          'product-card'
        )
        .forEach(
          processCard
        );
    }
  }


  function init() {
    walk(
      document.body
    );

    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            mutation
              .addedNodes
              .forEach(
                walk
              );
          }
        );
      }
    ).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();


/* =========================================================
 * 2) KEEP JUDGE.ME BEFORE HELLO RETAIL
 * ========================================================= */
(function () {
  'use strict';

  var judgeSelector =
    '[id$="__178777234009686e1f"]';


  function init() {
    var main =
      document.querySelector(
        'main#main'
      );

    if (!main) {
      return;
    }


    var scheduled =
      false;


    function reorder() {
      scheduled =
        false;

      var judge =
        main.querySelector(
          judgeSelector
        );

      if (!judge) {
        return;
      }


      var boxes =
        Array.prototype.slice
          .call(
            main.children
          )
          .filter(
            function (element) {
              return (
                element.id &&
                element.id.indexOf(
                  'aw-box-'
                ) === 0
              );
            }
          );


      if (!boxes.length) {
        return;
      }


      var anchor =
        judge;


      boxes.forEach(
        function (box) {
          if (
            box.previousElementSibling !==
            anchor
          ) {
            anchor.insertAdjacentElement(
              'afterend',
              box
            );
          }

          anchor =
            box;
        }
      );
    }


    function schedule() {
      if (scheduled) {
        return;
      }

      scheduled =
        true;

      requestAnimationFrame(
        reorder
      );
    }


    schedule();


    new MutationObserver(
      schedule
    ).observe(
      main,
      {
        childList: true
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();


/* =========================================================
 * 3) JUDGE.ME CUSTOM REVIEW DESIGN
 * ========================================================= */
(function () {
  'use strict';


  var sectionSelector =
    '[id$="__178777234009686e1f"]';

  var initialized =
    false;

  var resizeScheduled =
    false;



  /* =======================================================
   * HELPERS
   * ======================================================= */

  function normalizeText(value) {
    return (
      value || ''
    )
      .replace(
        /\u00a0/g,
        ' '
      )
      .replace(
        /\s+/g,
        ' '
      )
      .trim()
      .toLowerCase();
  }


  function findTextElement(
    texts,
    root
  ) {
    root =
      root ||
      document.querySelector(
        'main#main'
      ) ||
      document.body;


    var wanted =
      texts.map(
        normalizeText
      );


    var walker =
      document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );


    var node;


    while (
      (
        node =
          walker.nextNode()
      )
    ) {
      if (
        wanted.indexOf(
          normalizeText(
            node.nodeValue
          )
        ) !== -1
      ) {
        return (
          node.parentElement
        );
      }
    }


    return null;
  }



  function findHelloRetailHeading() {
    var boxes =
      document.querySelectorAll(
        'main#main [id^="aw-box-"]'
      );


    for (
      var i = 0;
      i < boxes.length;
      i++
    ) {
      var heading =
        findTextElement(
          [
            'Lignende produkter'
          ],
          boxes[i]
        );

      if (heading) {
        return heading;
      }
    }


    return null;
  }



  function findBodyReference() {
    return (
      findTextElement(
        [
          'Specifikationer',
          'Levering og returnering'
        ]
      )
    );
  }



  function findPurchaseButton() {
    return (
      document.querySelector(
        'main-product product-form .jf-no-variant.button'
      ) ||

      document.querySelector(
        'main-product product-form buy-buttons .button[type="submit"]'
      ) ||

      document.querySelector(
        'product-form buy-buttons .button[type="submit"]'
      )
    );
  }



  function copyTypography(
    source,
    target
  ) {
    if (
      !source ||
      !target
    ) {
      return false;
    }


    var computed =
      getComputedStyle(
        source
      );


    [
      'font-family',
      'font-size',
      'font-weight',
      'font-style',
      'font-stretch',
      'font-variant',
      'font-kerning',
      'font-feature-settings',
      'font-variation-settings',
      'font-optical-sizing',
      'font-size-adjust',
      'font-synthesis',
      'line-height',
      'letter-spacing',
      'word-spacing',
      'text-transform',
      'text-rendering',
      '-webkit-font-smoothing'
    ].forEach(
      function (property) {
        var value =
          computed.getPropertyValue(
            property
          );

        if (value) {
          target.style.setProperty(
            property,
            value,
            'important'
          );
        }
      }
    );


    return true;
  }



  /* =======================================================
   * WRITE REVIEW BUTTON
   * ======================================================= */

  function findWriteReviewTrigger(
    section
  ) {
    var elements =
      section.querySelectorAll(
        'button, a'
      );


    for (
      var i = 0;
      i < elements.length;
      i++
    ) {
      if (
        elements[i]
          .classList
          .contains(
            'jf-review-empty-button'
          )
      ) {
        continue;
      }


      var text =
        normalizeText(
          elements[i]
            .textContent
        );


      if (
        text.indexOf(
          'skriv en anmeldelse'
        ) !== -1 ||

        text.indexOf(
          'write a review'
        ) !== -1
      ) {
        return elements[i];
      }
    }


    return null;
  }



  function ensureOriginalTrigger(
    section
  ) {
    var existing =
      section.querySelector(
        '.jf-original-review-trigger'
      );


    if (existing) {
      return existing;
    }


    var trigger =
      findWriteReviewTrigger(
        section
      );


    if (trigger) {
      trigger.classList.add(
        'jf-original-review-trigger'
      );
    }


    return trigger;
  }



  /* =======================================================
   * REVIEW DATA
   * ======================================================= */

  function extractReviewCount(
    section
  ) {
    var text =
      (
        section.innerText ||
        ''
      )
        .replace(
          /\u00a0/g,
          ' '
        )
        .replace(
          /\s+/g,
          ' '
        );


    var patterns = [
      /([0-9]+)\s+anmeldelser/i,
      /([0-9]+)\s+anmeldelse/i,
      /([0-9]+)\s+reviews?/i
    ];


    for (
      var i = 0;
      i < patterns.length;
      i++
    ) {
      var result =
        text.match(
          patterns[i]
        );

      if (result) {
        return parseInt(
          result[1],
          10
        );
      }
    }


    return null;
  }



  function extractAverageRating(
    section
  ) {
    var text =
      (
        section.innerText ||
        ''
      )
        .replace(
          ',',
          '.'
        )
        .replace(
          /\u00a0/g,
          ' '
        )
        .replace(
          /\s+/g,
          ' '
        );


    var match =
      text.match(
        /(?:^|\s)([1-5](?:\.[0-9]{1,2})?)(?:\s|$)/
      );


    if (!match) {
      return null;
    }


    var rating =
      parseFloat(
        match[1]
      );


    return (
      rating >= 1 &&
      rating <= 5
    )
      ? rating
      : null;
  }



  function buildStars(
    rating
  ) {
    var rounded =
      Math.round(
        rating || 5
      );


    var stars =
      '';


    for (
      var i = 1;
      i <= 5;
      i++
    ) {
      stars +=
        i <= rounded
          ? '★'
          : '☆';
    }


    return stars;
  }



  /* =======================================================
   * CUSTOM REVIEW SUMMARY
   * ======================================================= */

  function ensureReviewHeader(
    section
  ) {
    var count =
      extractReviewCount(
        section
      ) || 1;


    var rating =
      extractAverageRating(
        section
      ) || 5;


    var widget =
      section.querySelector(
        '.jm-review-widget'
      ) ||

      section.querySelector(
        '[class*="jm-review-widget"]'
      );


    if (!widget) {
      return;
    }


    widget.classList.add(
      'jf-review-full-content'
    );


    var existing =
      section.querySelector(
        '.jf-review-summary'
      );


    if (existing) {
      var stars =
        existing.querySelector(
          '.jf-review-summary-stars'
        );

      var ratingText =
        existing.querySelector(
          '.jf-review-summary-rating'
        );

      var countText =
        existing.querySelector(
          '.jf-review-summary-count'
        );


      if (stars) {
        stars.textContent =
          buildStars(
            rating
          );
      }


      if (ratingText) {
        ratingText.textContent =
          rating
            .toFixed(1)
            .replace(
              '.',
              ','
            );
      }


      if (countText) {
        countText.textContent =
          count === 1
            ? '1 anmeldelse'
            : count +
              ' anmeldelser';
      }


      return;
    }


    var summary =
      document.createElement(
        'div'
      );


    summary.className =
      'jf-review-summary';


    summary.setAttribute(
      'role',
      'button'
    );


    summary.setAttribute(
      'tabindex',
      '0'
    );


    summary.setAttribute(
      'aria-expanded',
      'true'
    );


    summary.innerHTML =
      '<div class="jf-review-summary-info">' +

        '<div class="jf-review-summary-title">' +
          'Kundeanmeldelser' +
        '</div>' +

        '<div class="jf-review-summary-meta">' +

          '<span class="jf-review-summary-stars">' +
            buildStars(
              rating
            ) +
          '</span>' +

          '<span class="jf-review-summary-rating">' +
            rating
              .toFixed(1)
              .replace(
                '.',
                ','
              ) +
          '</span>' +

          '<span class="jf-review-summary-dot">' +
            '·' +
          '</span>' +

          '<span class="jf-review-summary-count">' +
            (
              count === 1
                ? '1 anmeldelse'
                : count +
                  ' anmeldelser'
            ) +
          '</span>' +

        '</div>' +

      '</div>' +

      '<div class="jf-review-summary-action">' +

        '<span class="jf-review-toggle-label">' +
          'Skjul' +
        '</span>' +

        '<span class="jf-review-chevron" aria-hidden="true"></span>' +

      '</div>';


    widget.insertAdjacentElement(
      'beforebegin',
      summary
    );


    function updateToggle() {
      var open =
        section.classList.contains(
          'jf-reviews-open'
        );


      summary.setAttribute(
        'aria-expanded',
        open
          ? 'true'
          : 'false'
      );


      var label =
        summary.querySelector(
          '.jf-review-toggle-label'
        );


      if (label) {
        label.textContent =
          open
            ? 'Skjul'
            : 'Vis anmeldelser';
      }
    }


    function toggle() {
      section.classList.toggle(
        'jf-reviews-open'
      );


      section.setAttribute(
        'data-jf-review-user-state',
        section.classList.contains(
          'jf-reviews-open'
        )
          ? 'open'
          : 'closed'
      );


      updateToggle();
    }


    summary.addEventListener(
      'click',
      function (event) {
        if (
          !event.target.closest(
            'a, button'
          )
        ) {
          toggle();
        }
      }
    );


    summary.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Enter' ||
          event.key === ' '
        ) {
          event.preventDefault();

          toggle();
        }
      }
    );


    updateToggle();
  }



  /* =======================================================
   * HIDE DUPLICATE JUDGE.ME HEADER
   * ======================================================= */

  function hideDuplicateJudgeHeader(
    section
  ) {
    var header =
      section.querySelector(
        '.jm-review-widget__header'
      );


    if (!header) {
      return;
    }


    var elements =
      header.querySelectorAll(
        '*'
      );


    for (
      var i = 0;
      i < elements.length;
      i++
    ) {
      var element =
        elements[i];


      var text =
        normalizeText(
          element.textContent
        );


      if (
        text.indexOf(
          'kundeanmeldelser'
        ) !== -1 &&

        (
          text.indexOf(
            'anmeldelse'
          ) !== -1 ||

          text.indexOf(
            'review'
          ) !== -1
        ) &&

        !element.querySelector(
          'button'
        )
      ) {
        var candidate =
          element;


        while (
          candidate.parentElement &&
          candidate.parentElement !== header &&
          !candidate
            .parentElement
            .querySelector(
              'button'
            )
        ) {
          var parentText =
            normalizeText(
              candidate
                .parentElement
                .textContent
            );


          if (
            parentText.indexOf(
              'kundeanmeldelser'
            ) === -1
          ) {
            break;
          }


          candidate =
            candidate.parentElement;
        }


        candidate.classList.add(
          'jf-hide-duplicate-review-summary'
        );


        break;
      }
    }
  }



  /* =======================================================
   * REMOVE WHITE INTERNAL BACKGROUNDS
   * ======================================================= */

  function clearWhiteReviewBackgrounds(
    section
  ) {
    if (
      !section.classList.contains(
        'jf-judgeme-has-reviews'
      )
    ) {
      return;
    }


    section
      .querySelectorAll(
        '*'
      )
      .forEach(
        function (element) {
          if (
            element.matches(
              'button, input, select, textarea, option, img, svg, video'
            )
          ) {
            return;
          }


          if (
            element.closest(
              'button, input, select, textarea'
            )
          ) {
            return;
          }


          var background =
            getComputedStyle(
              element
            ).backgroundColor;


          if (
            background ===
              'rgb(255, 255, 255)' ||

            background ===
              'rgba(255, 255, 255, 1)'
          ) {
            element.style.setProperty(
              'background',
              'transparent',
              'important'
            );


            element.style.setProperty(
              'background-color',
              'transparent',
              'important'
            );
          }
        }
      );
  }



  /* =======================================================
   * ZERO REVIEWS
   * ======================================================= */

  function setupZeroReviewCard(
    section
  ) {
    section.classList.remove(
      'jf-judgeme-has-reviews',
      'jf-reviews-open'
    );


    section.removeAttribute(
      'data-jf-review-user-state'
    );


    section.classList.add(
      'jf-judgeme-empty'
    );


    var summary =
      section.querySelector(
        '.jf-review-summary'
      );


    if (summary) {
      summary.remove();
    }


    ensureOriginalTrigger(
      section
    );


    var card =
      section.querySelector(
        '.jf-review-empty-card'
      );


    if (!card) {
      card =
        document.createElement(
          'div'
        );


      card.className =
        'jf-review-empty-card';


      card.innerHTML =
        '<div class="jf-review-empty-content">' +

          '<h2 class="h7 jf-review-empty-title">' +
            'Har du prøvet produktet?' +
          '</h2>' +

          '<p class="jf-review-empty-text">' +
            'Hjælp andre lystfiskere ved at dele din erfaring med produktet.' +
          '</p>' +

        '</div>' +

        '<button type="button" class="button jf-review-empty-button">' +

          '<button-content class="button__content">' +
            'Skriv en anmeldelse' +
          '</button-content>' +

        '</button>';


      section.appendChild(
        card
      );


      var button =
        card.querySelector(
          '.jf-review-empty-button'
        );


      button.addEventListener(
        'click',
        function () {
          var trigger =
            ensureOriginalTrigger(
              section
            );


          if (
            trigger &&
            trigger !== button
          ) {
            trigger.click();
          }
        }
      );
    }
  }



  /* =======================================================
   * HAS REVIEWS
   * ======================================================= */

  function setupHasReviews(
    section
  ) {
    section.classList.remove(
      'jf-judgeme-empty'
    );


    section.classList.add(
      'jf-judgeme-has-reviews'
    );


    var state =
      section.getAttribute(
        'data-jf-review-user-state'
      );


    if (
      !state ||
      state === 'open'
    ) {
      section.classList.add(
        'jf-reviews-open'
      );
    } else {
      section.classList.remove(
        'jf-reviews-open'
      );
    }


    var emptyCard =
      section.querySelector(
        '.jf-review-empty-card'
      );


    if (emptyCard) {
      emptyCard.remove();
    }


    ensureReviewHeader(
      section
    );


    hideDuplicateJudgeHeader(
      section
    );


    clearWhiteReviewBackgrounds(
      section
    );
  }



  function setupReviewArea() {
    var section =
      document.querySelector(
        sectionSelector
      );


    if (!section) {
      return;
    }


    if (
      section.querySelector(
        '.jm-no-reviews-state'
      )
    ) {
      setupZeroReviewCard(
        section
      );
    } else {
      setupHasReviews(
        section
      );
    }
  }



  /* =======================================================
   * BUTTON APPEARANCE
   * ======================================================= */

  function copyButtonShape(
    source,
    target
  ) {
    if (
      !source ||
      !target
    ) {
      return;
    }


    var computed =
      getComputedStyle(
        source
      );


    [
      'border-top-width',
      'border-right-width',
      'border-bottom-width',
      'border-left-width',

      'border-top-style',
      'border-right-style',
      'border-bottom-style',
      'border-left-style',

      'border-top-left-radius',
      'border-top-right-radius',
      'border-bottom-right-radius',
      'border-bottom-left-radius',

      'height',
      'min-height',

      'padding-top',
      'padding-right',
      'padding-bottom',
      'padding-left'
    ].forEach(
      function (property) {
        var value =
          computed.getPropertyValue(
            property
          );


        if (value) {
          target.style.setProperty(
            property,
            value,
            'important'
          );
        }
      }
    );


    copyTypography(
      source,
      target
    );
  }



  function makeSecondaryButton(
    button
  ) {
    if (!button) {
      return;
    }


    button.classList.add(
      'jf-review-write-button'
    );


    button.style.setProperty(
      '--button-background',
      '243 243 243',
      'important'
    );


    button.style.setProperty(
      '--button-text-color',
      '49 51 51',
      'important'
    );


    button.style.setProperty(
      'background',
      'transparent',
      'important'
    );


    button.style.setProperty(
      'background-color',
      'transparent',
      'important'
    );


    button.style.setProperty(
      'color',
      '#313333',
      'important'
    );


    button.style.setProperty(
      'border-color',
      'rgba(49, 51, 51, .42)',
      'important'
    );


    button.style.setProperty(
      'box-shadow',
      'none',
      'important'
    );
  }



  function syncHeaderTypography(
    section
  ) {
    var headingSource =
      findHelloRetailHeading();


    var bodySource =
      findBodyReference();


    var purchaseButton =
      findPurchaseButton();


    var title =
      section.querySelector(
        '.jf-review-summary-title'
      );


    var emptyTitle =
      section.querySelector(
        '.jf-review-empty-title'
      );


    var meta =
      section.querySelector(
        '.jf-review-summary-meta'
      );


    var action =
      section.querySelector(
        '.jf-review-summary-action'
      );


    var emptyText =
      section.querySelector(
        '.jf-review-empty-text'
      );


    var emptyButton =
      section.querySelector(
        '.jf-review-empty-button'
      );


    var writeButton =
      findWriteReviewTrigger(
        section
      );


    if (
      headingSource &&
      title
    ) {
      copyTypography(
        headingSource,
        title
      );
    }


    if (
      headingSource &&
      emptyTitle
    ) {
      copyTypography(
        headingSource,
        emptyTitle
      );
    }


    if (
      bodySource &&
      meta
    ) {
      copyTypography(
        bodySource,
        meta
      );
    }


    if (
      bodySource &&
      action
    ) {
      copyTypography(
        bodySource,
        action
      );
    }


    if (
      bodySource &&
      emptyText
    ) {
      copyTypography(
        bodySource,
        emptyText
      );
    }


    if (
      purchaseButton &&
      emptyButton
    ) {
      copyButtonShape(
        purchaseButton,
        emptyButton
      );

      makeSecondaryButton(
        emptyButton
      );
    }


    if (
      purchaseButton &&
      writeButton
    ) {
      copyTypography(
        purchaseButton,
        writeButton
      );

      makeSecondaryButton(
        writeButton
      );
    }
  }



  /* =======================================================
   * REVIEW TYPOGRAPHY
   * ======================================================= */

  function syncReviewTypography(
    section
  ) {
    var bodySource =
      findBodyReference();


    var headingSource =
      findHelloRetailHeading();


    if (!bodySource) {
      return;
    }


    var bodyStyle =
      getComputedStyle(
        bodySource
      );


    var headingStyle =
      headingSource
        ? getComputedStyle(
            headingSource
          )
        : null;


    var mobile =
      matchMedia(
        '(max-width: 749px)'
      ).matches;


    section
      .querySelectorAll(
        '.jm-review'
      )
      .forEach(
        function (review) {
          copyTypography(
            bodySource,
            review
          );


          review.style.setProperty(
            'font-weight',
            '400',
            'important'
          );


          /*
           * =================================================
           * REVIEWER NAME
           * =================================================
           */

          var reviewerName =
            review.querySelector(
              '.jm-reviewer-info__name'
            );


          if (reviewerName) {
            reviewerName.style.setProperty(
              '--text-weight',
              '500',
              'important'
            );


            reviewerName.style.setProperty(
              'font-weight',
              '500',
              'important'
            );


            reviewerName.style.setProperty(
              'font-size',
              bodyStyle.fontSize,
              'important'
            );


            reviewerName.style.setProperty(
              'line-height',
              '1.3',
              'important'
            );


            reviewerName.style.setProperty(
              'font-synthesis',
              'none',
              'important'
            );


            if (headingStyle) {
              reviewerName.style.setProperty(
                'font-family',
                headingStyle.fontFamily,
                'important'
              );


              reviewerName.style.setProperty(
                'font-style',
                headingStyle.fontStyle,
                'important'
              );


              reviewerName.style.setProperty(
                'letter-spacing',
                headingStyle.letterSpacing,
                'important'
              );


              reviewerName.style.setProperty(
                'text-transform',
                headingStyle.textTransform,
                'important'
              );
            }
          }


          /*
           * =================================================
           * REVIEW BODY TEXT
           * =================================================
           */

          review
            .querySelectorAll(
              '.jm-review-content, .jm-review-content .jm-text, .jm-review-content p, .jm-review-content span'
            )
            .forEach(
              function (textNode) {
                textNode.style.setProperty(
                  '--text-size',
                  bodyStyle.fontSize,
                  'important'
                );


                textNode.style.setProperty(
                  '--text-weight',
                  '400',
                  'important'
                );


                textNode.style.setProperty(
                  'font-family',
                  bodyStyle.fontFamily,
                  'important'
                );


                textNode.style.setProperty(
                  'font-size',
                  bodyStyle.fontSize,
                  'important'
                );


                textNode.style.setProperty(
                  'font-weight',
                  '400',
                  'important'
                );


                textNode.style.setProperty(
                  'font-style',
                  bodyStyle.fontStyle,
                  'important'
                );


                textNode.style.setProperty(
                  'line-height',
                  bodyStyle.lineHeight,
                  'important'
                );


                textNode.style.setProperty(
                  'letter-spacing',
                  bodyStyle.letterSpacing,
                  'important'
                );


                textNode.style.setProperty(
                  'word-spacing',
                  bodyStyle.wordSpacing,
                  'important'
                );


                textNode.style.setProperty(
                  'text-transform',
                  'none',
                  'important'
                );


                textNode.style.setProperty(
                  'font-synthesis',
                  'none',
                  'important'
                );
              }
            );


          var verified =
            review.querySelector(
              '.jm-verified-buyer-badge'
            );


          if (verified) {
            verified.style.setProperty(
              'font-size',
              mobile
                ? '10px'
                : '11px',
              'important'
            );


            verified.style.setProperty(
              'font-weight',
              '400',
              'important'
            );


            verified.style.setProperty(
              'line-height',
              '1.2',
              'important'
            );
          }


          review
            .querySelectorAll(
              [
                '[class*="star"]',
                '[aria-label*="star" i]',
                '[aria-label*="rating" i]'
              ].join(',')
            )
            .forEach(
              function (star) {
                star.style.setProperty(
                  'font-size',
                  mobile
                    ? '18px'
                    : '20px',
                  'important'
                );


                star.style.setProperty(
                  'line-height',
                  '1',
                  'important'
                );
              }
            );
        }
      );
  }



  /* =======================================================
   * CSS
   * ======================================================= */

  var style =
    document.createElement(
      'style'
    );


  style.textContent = `

    /* =====================================================
     * ZERO REVIEWS
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-empty {
      box-sizing:
        border-box;

      margin-top:
        -160px !important;

      margin-bottom:
        0 !important;

      padding:
        24px 0 !important;

      min-height:
        0 !important;

      --section-vertical-spacing:
        0px !important;

      --section-stack-gap:
        0px !important;
    }


    /* =====================================================
     * PRODUCT PAGE TOP REVIEW STARS
     * ===================================================== */

    .jdgm-preview-badge .jdgm-star,
    .jdgm-preview-badge .jdgm-star::before,
    .jdgm-prev-badge .jdgm-star,
    .jdgm-prev-badge .jdgm-star::before,
    .jdgm-widget .jdgm-star,
    .jdgm-widget .jdgm-star::before {
      color:
        #111111 !important;
    }


    .jdgm-preview-badge,
    .jdgm-preview-badge .jdgm-prev-badge__text,
    .jdgm-prev-badge,
    .jdgm-prev-badge__text {
      color:
        #313333 !important;
    }


    ${sectionSelector}.jf-judgeme-empty > .section,
    ${sectionSelector}.jf-judgeme-empty > .section-spacing,
    ${sectionSelector}.jf-judgeme-empty > .section-stack,

    ${sectionSelector}.jf-judgeme-empty .section,
    ${sectionSelector}.jf-judgeme-empty .section-spacing,
    ${sectionSelector}.jf-judgeme-empty .section-stack,

    ${sectionSelector}.jf-judgeme-has-reviews > .section,
    ${sectionSelector}.jf-judgeme-has-reviews > .section-spacing,
    ${sectionSelector}.jf-judgeme-has-reviews > .section-stack,

    ${sectionSelector}.jf-judgeme-has-reviews .section,
    ${sectionSelector}.jf-judgeme-has-reviews .section-spacing,
    ${sectionSelector}.jf-judgeme-has-reviews .section-stack {
      margin:
        0 !important;

      padding-top:
        0 !important;

      padding-bottom:
        0 !important;

      min-height:
        0 !important;
    }


    ${sectionSelector}.jf-judgeme-empty
    .jm-review-widget__header,

    ${sectionSelector}.jf-judgeme-empty
    .jm-review-widget-minimal-header,

    ${sectionSelector}.jf-judgeme-empty
    .jm-no-reviews-state,

    ${sectionSelector}.jf-judgeme-empty
    .jm-review-widget__body {
      position:
        absolute !important;

      width:
        1px !important;

      height:
        1px !important;

      overflow:
        hidden !important;

      opacity:
        0 !important;

      pointer-events:
        none !important;

      clip:
        rect(0 0 0 0) !important;

      clip-path:
        inset(50%) !important;

      white-space:
        nowrap !important;
    }


    ${sectionSelector}
    .jf-review-empty-card {
      box-sizing:
        border-box;

      width: calc(
        100vw -
        (2 * var(--container-gutter))
      );

      max-width:
        var(--container-max-width);

      position:
        relative;

      left:
        50%;

      transform:
        translateX(-50%);

      margin:
        0;

      padding-block:
        var(--spacing-2);

      padding-inline:
        var(--spacing-2);

      background:
        #f3f3f3;

      border-radius:
        8px;

      display:
        flex;

      align-items:
        center;

      justify-content:
        space-between;

      gap:
        var(--spacing-3);

      color:
        rgb(
          var(
            --text-color,
            49 51 51
          )
        );
    }


    ${sectionSelector}
    .jf-review-empty-content {
      min-width:
        0;

      flex:
        1 1 auto;
    }


    ${sectionSelector}
    .jf-review-empty-title {
      margin:
        0 0 5px 0;

      color:
        inherit;
    }


    ${sectionSelector}
    .jf-review-empty-text {
      margin:
        0;

      color:
        inherit;

      opacity:
        .7;
    }



    /* =====================================================
     * SECONDARY REVIEW BUTTON
     * ===================================================== */

    ${sectionSelector}
    .jf-review-empty-button,

    ${sectionSelector}
    .jf-review-write-button {
      --button-background:
        243 243 243 !important;

      --button-text-color:
        49 51 51 !important;

      background:
        transparent !important;

      background-color:
        transparent !important;

      color:
        #313333 !important;

      border:
        1px solid rgba(
          49,
          51,
          51,
          .42
        ) !important;

      box-shadow:
        none !important;
    }


    ${sectionSelector}
    .jf-review-empty-button {
      flex:
        0 0 auto;

      width:
        auto;

      white-space:
        nowrap;
    }


    ${sectionSelector}
    .jf-review-empty-button
    .button__content {
      color:
        #313333 !important;
    }


    ${sectionSelector}
    .jf-review-empty-button:hover,

    ${sectionSelector}
    .jf-review-write-button:hover {
      background:
        rgba(
          49,
          51,
          51,
          .055
        ) !important;

      background-color:
        rgba(
          49,
          51,
          51,
          .055
        ) !important;

      border-color:
        rgba(
          49,
          51,
          51,
          .62
        ) !important;
    }



    /* =====================================================
     * REVIEW BOX
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews {
      box-sizing:
        border-box;

      width: calc(
        100vw -
        (2 * var(--container-gutter))
      );

      max-width:
        var(--container-max-width);

      margin-inline:
        auto !important;

      margin-top:
        -34px !important;

      margin-bottom:
        30px !important;

      padding:
        26px 0 18px 0 !important;

      background:
        #f3f3f3 !important;

      border-radius:
        8px;

      overflow:
        hidden;

      min-height:
        0 !important;

      height:
        auto !important;
    }



    /* =====================================================
     * CUSTOM SUMMARY
     * ===================================================== */

    ${sectionSelector}
    .jf-review-summary {
      box-sizing:
        border-box;

      width:
        100%;

      min-height:
        0;

      padding:
        7px 16px !important;

      display:
        flex;

      align-items:
        center;

      justify-content:
        space-between;

      gap:
        18px;

      background:
        #f3f3f3;

      color:
        rgb(
          var(
            --text-color,
            49 51 51
          )
        );

      cursor:
        pointer;

      user-select:
        none;

      transition:
        background-color .15s ease;
    }


    ${sectionSelector}
    .jf-review-summary:hover {
      background:
        #ededed;
    }


    ${sectionSelector}
    .jf-review-summary-info {
      min-width:
        0;
    }


    ${sectionSelector}
    .jf-review-summary-title {
      margin:
        0 0 3px 0 !important;

      color:
        inherit;
    }


    ${sectionSelector}
    .jf-review-summary-meta {
      display:
        flex;

      align-items:
        center;

      flex-wrap:
        wrap;

      gap:
        6px;
    }


    ${sectionSelector}
    .jf-review-summary-stars {
      display:
        inline-flex;

      align-items:
        center;

      color:
        #111;

      font-size:
        16px !important;

      line-height:
        1 !important;

      letter-spacing:
        1px !important;
    }


    ${sectionSelector}
    .jf-review-summary-rating {
      font-weight:
        500 !important;
    }


    ${sectionSelector}
    .jf-review-summary-dot {
      opacity:
        .4;
    }


    ${sectionSelector}
    .jf-review-summary-count {
      opacity:
        .7;
    }


    ${sectionSelector}
    .jf-review-summary-action {
      flex:
        0 0 auto;

      display:
        flex;

      align-items:
        center;

      gap:
        8px;

      padding-left:
        12px;

      color:
        #313333;
    }


    ${sectionSelector}
    .jf-review-toggle-label {
      white-space:
        nowrap;

      opacity:
        .72;
    }


    ${sectionSelector}
    .jf-review-chevron {
      display:
        block;

      width:
        8px;

      height:
        8px;

      border-right:
        1.5px solid currentColor;

      border-bottom:
        1.5px solid currentColor;

      transform:
        rotate(45deg);

      transition:
        transform .18s ease;

      opacity:
        .72;
    }


    ${sectionSelector}.jf-reviews-open
    .jf-review-chevron {
      transform:
        rotate(225deg);

      margin-top:
        4px;
    }


    ${sectionSelector}
    .jf-hide-duplicate-review-summary {
      display:
        none !important;
    }



    /* =====================================================
     * EXPAND / COLLAPSE
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jf-review-full-content {
      display:
        none !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews.jf-reviews-open
    .jf-review-full-content {
      display:
        block !important;

      padding:
        5px 16px 0 16px !important;

      margin:
        0 !important;

      min-height:
        0 !important;

      height:
        auto !important;

      border-top:
        1px solid rgba(
          49,
          51,
          51,
          .10
        );
    }



    /* =====================================================
     * REMOVE JUDGE.ME EXTRA HEIGHT
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__container,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__content,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__header,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__body,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__reviews,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__review-list,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-list {
      min-height:
        0 !important;

      height:
        auto !important;

      max-height:
        none !important;

      margin-top:
        0 !important;

      margin-bottom:
        0 !important;

      padding-top:
        0 !important;

      padding-bottom:
        0 !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__header {
      margin:
        0 !important;

      padding:
        0 !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__body {
      margin-top:
        -10px !important;

      margin-bottom:
        0 !important;

      padding:
        0 !important;
    }



    /* =====================================================
     * INDIVIDUAL REVIEW
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review {
      min-height:
        0 !important;

      height:
        auto !important;

      margin:
        0 !important;

      padding:
        4px 0 !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review:first-child {
      margin-top:
        -4px !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review:last-child {
      padding-bottom:
        0 !important;

      margin-bottom:
        -8px !important;
    }



    /* =====================================================
     * REVIEWER NAME
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-reviewer-info__name {
      --text-weight:
        500 !important;

      font-family:
        var(
          --heading-font-family
        ) !important;

      font-size:
        var(
          --text-base
        ) !important;

      font-weight:
        500 !important;

      font-style:
        var(
          --heading-font-style,
          normal
        ) !important;

      line-height:
        1.3 !important;

      letter-spacing:
        var(
          --heading-letter-spacing,
          0
        ) !important;

      text-transform:
        var(
          --heading-text-transform,
          none
        ) !important;

      font-synthesis:
        none !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-reviewer-info__name * {
      font-family:
        inherit !important;

      font-size:
        inherit !important;

      font-weight:
        500 !important;

      font-synthesis:
        none !important;

      line-height:
        inherit !important;
    }



    /* =====================================================
     * STAR → REVIEWER SPACING
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review
    [class*="rating"],

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review
    [class*="stars"] {
      margin-bottom:
        3px !important;
    }



    /* =====================================================
     * REVIEW BODY TEXT
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-content,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-content .jm-text,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-content p,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-content span {
      --text-weight:
        400 !important;

      font-family:
        var(--text-font-family) !important;

      font-size:
        var(--text-base) !important;

      font-weight:
        400 !important;

      font-style:
        var(--text-font-style, normal) !important;

      line-height:
        var(--text-line-height, 1.5) !important;

      letter-spacing:
        var(--text-letter-spacing, 0.005em) !important;

      text-transform:
        none !important;

      font-synthesis:
        none !important;
    }



    /* =====================================================
     * VERIFIED BADGE
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-verified-buyer-badge,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review
    [class*="verified"],

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review
    [class*="badge"] {
      font-size:
        11px !important;

      font-weight:
        400 !important;

      line-height:
        1.2 !important;
    }



    /* =====================================================
     * FOOTER
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__footer {
      margin:
        0 !important;

      padding:
        0 !important;

      min-height:
        0 !important;
    }


    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__footer:empty {
      display:
        none !important;
    }



    /* =====================================================
     * TRANSPARENT INTERNAL BACKGROUNDS
     * ===================================================== */

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__container,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__content,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__header,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__body,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__reviews,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review-widget__review-list,

    ${sectionSelector}.jf-judgeme-has-reviews
    .jm-review {
      background:
        transparent !important;

      background-color:
        transparent !important;
    }



    /* =====================================================
     * MOBILE
     * ===================================================== */

    @media screen and (max-width: 749px) {

      ${sectionSelector}.jf-judgeme-empty {
        margin-top:
          -128px !important;

        margin-bottom:
          0 !important;

        padding:
          8px 0 16px 0 !important;
      }


      ${sectionSelector}
      .jf-review-empty-card {
        width: calc(
          100vw -
          (2 * var(--container-gutter))
        );

        padding-block:
          var(--spacing-2);

        padding-inline:
          var(--spacing-2);

        flex-direction:
          column;

        align-items:
          stretch;

        gap:
          var(--spacing-2);
      }


      ${sectionSelector}
      .jf-review-empty-button {
        width:
          100% !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews {
        width: calc(
          100vw -
          (2 * var(--container-gutter))
        );

        margin-top:
          -14px !important;

        margin-bottom:
          20px !important;

        padding:
          14px 0 10px 0 !important;

        border-radius:
          8px;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jf-review-summary {
        padding:
          5px 10px 6px 10px !important;

        gap:
          8px !important;
      }


      ${sectionSelector}
      .jf-review-summary-info {
        flex:
          1 1 auto;

        min-width:
          0;
      }


      ${sectionSelector}
      .jf-review-summary-title {
        margin:
          0 0 3px 0 !important;
      }


      ${sectionSelector}
      .jf-review-summary-meta {
        gap:
          4px !important;

        row-gap:
          2px !important;
      }


      ${sectionSelector}
      .jf-review-summary-stars {
        font-size:
          14px !important;

        letter-spacing:
          .6px !important;
      }


      ${sectionSelector}
      .jf-review-summary-action {
        padding-left:
          5px !important;

        gap:
          5px !important;
      }


      ${sectionSelector}
      .jf-review-chevron {
        width:
          7px;

        height:
          7px;
      }


      ${sectionSelector}.jf-judgeme-has-reviews.jf-reviews-open
      .jf-review-full-content {
        padding:
          3px 10px 2px 10px !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header {
        width:
          100% !important;

        margin:
          0 !important;

        padding:
          0 0 2px 0 !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header > * {
        max-width:
          100% !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header button,

      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header a {
        min-height:
          46px !important;

        height:
          46px !important;

        max-width:
          100%;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__body {
        margin-top:
          -18px !important;

        margin-bottom:
          0 !important;

        padding:
          0 !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review:first-child {
        margin-top:
          0 !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review {
        margin:
          0 !important;

        padding:
          0 !important;

        min-height:
          0 !important;

        height:
          auto !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-reviewer-info__name {
        --text-weight:
          500 !important;

        font-size:
          var(
            --text-base
          ) !important;

        font-weight:
          500 !important;

        line-height:
          1.3 !important;

        font-synthesis:
          none !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review
      [class*="star"] {
        font-size:
          18px !important;

        line-height:
          1 !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-verified-buyer-badge,

      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review
      [class*="verified"],

      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review
      [class*="badge"] {
        font-size:
          10px !important;

        font-weight:
          400 !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review:last-child {
        padding-bottom:
          0 !important;

        margin-bottom:
          -18px !important;
      }

    }



    /* =====================================================
     * SMALL MOBILE
     * ===================================================== */

    @media screen and (max-width: 389px) {

      ${sectionSelector}.jf-judgeme-has-reviews
      .jf-review-summary {
        padding-left:
          9px !important;

        padding-right:
          9px !important;

        gap:
          6px !important;
      }


      ${sectionSelector}
      .jf-review-summary-meta {
        gap:
          3px !important;

        row-gap:
          2px !important;
      }


      ${sectionSelector}
      .jf-review-summary-stars {
        font-size:
          13px !important;

        letter-spacing:
          .4px !important;
      }


      ${sectionSelector}
      .jf-review-summary-action {
        padding-left:
          3px !important;

        gap:
          4px !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews.jf-reviews-open
      .jf-review-full-content {
        padding-left:
          9px !important;

        padding-right:
          9px !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header button,

      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review-widget__header a {
        min-height:
          44px !important;

        height:
          44px !important;
      }


      ${sectionSelector}.jf-judgeme-has-reviews
      .jm-review
      [class*="star"] {
        font-size:
          17px !important;
      }

    }
  `;


  document.head.appendChild(
    style
  );



  /* =======================================================
   * RUN
   * ======================================================= */

  function runSetup() {
    setupReviewArea();


    var section =
      document.querySelector(
        sectionSelector
      );


    if (!section) {
      return;
    }


    syncHeaderTypography(
      section
    );


    syncReviewTypography(
      section
    );


    hideDuplicateJudgeHeader(
      section
    );


    clearWhiteReviewBackgrounds(
      section
    );
  }



  function handleResize() {
    if (
      resizeScheduled
    ) {
      return;
    }


    resizeScheduled =
      true;


    requestAnimationFrame(
      function () {
        resizeScheduled =
          false;

        runSetup();
      }
    );
  }



  function init() {
    if (initialized) {
      return;
    }


    initialized =
      true;


    runSetup();


    var scheduled =
      false;


    new MutationObserver(
      function () {
        if (scheduled) {
          return;
        }


        scheduled =
          true;


        requestAnimationFrame(
          function () {
            scheduled =
              false;

            runSetup();
          }
        );
      }
    ).observe(
      document.body,
      {
        childList:
          true,

        subtree:
          true
      }
    );


    window.addEventListener(
      'resize',
      handleResize,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'orientationchange',
      function () {
        setTimeout(
          handleResize,
          150
        );
      }
    );


    if (
      document.fonts &&
      document.fonts.ready
    ) {
      document.fonts.ready.then(
        runSetup
      );
    }


    [
      100,
      300,
      600,
      1000,
      1500,
      3000,
      5000
    ].forEach(
      function (delay) {
        setTimeout(
          runSetup,
          delay
        );
      }
    );
  }



  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();


/* =========================================================
 * 5) STORE REVIEWS
 * Integreret nederst i "Om Justfishing"
 * Desktop godkendt + målrettet mobilfix til Judge.me v2
 * ========================================================= */
(function () {
  'use strict';

  var PRODUCT_REVIEW_SECTION =
    '[id$="__178777234009686e1f"]';

  var STORE_BLOCK_SELECTOR =
    '[id*="judge_me_reviews_review_snippet_widget"]';

  var STYLE_ID =
    'jf-store-reviews-about-integrated-v15';

  var WRAPPER_CLASS =
    'jf-store-reviews-integrated';

  var scheduled =
    false;


  /* =======================================================
   * HELPERS
   * ======================================================= */

  function normalize(value) {
    return (
      value || ''
    )
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function getMain() {
    return document.querySelector(
      'main#main'
    );
  }


  /* =======================================================
   * FIND "OM JUSTFISHING"
   * ======================================================= */

  function findBrandBlock() {
    var main =
      getMain();

    if (!main) {
      return null;
    }


    var exact =
      main.querySelector(
        '[data-jf-brand-pdp]'
      );

    if (exact) {
      return exact;
    }


    var sections =
      main.querySelectorAll(
        '[id^="shopify-section-"]'
      );


    for (
      var i = 0;
      i < sections.length;
      i++
    ) {
      var text =
        normalize(
          sections[i].textContent
        );


      if (
        text.indexOf(
          'fiskegrej med erfaring bag'
        ) !== -1 &&
        text.indexOf(
          'læs om justfishing'
        ) !== -1
      ) {
        var fallback =
          sections[i].querySelector(
            '[data-jf-brand-pdp]'
          );

        if (fallback) {
          return fallback;
        }
      }
    }


    return null;
  }


  /* =======================================================
   * FIND STORE REVIEW WIDGET
   * ======================================================= */

  function findStoreWidget() {
    var main =
      getMain();

    if (!main) {
      return null;
    }


    var exact =
      main.querySelector(
        STORE_BLOCK_SELECTOR
      );

    if (exact) {
      return exact;
    }


    var blocks =
      main.querySelectorAll(
        '.shopify-app-block'
      );


    for (
      var i = 0;
      i < blocks.length;
      i++
    ) {
      var block =
        blocks[i];


      if (
        block.closest(
          PRODUCT_REVIEW_SECTION
        )
      ) {
        continue;
      }


      var marker =
        (
          (block.id || '') +
          ' ' +
          (block.className || '')
        ).toLowerCase();


      if (
        marker.indexOf(
          'review_snippet'
        ) !== -1 ||
        marker.indexOf(
          'review-snippet'
        ) !== -1
      ) {
        return block;
      }
    }


    return null;
  }


  /* =======================================================
   * CREATE WRAPPER
   * ======================================================= */

  function createWrapper() {
    var wrapper =
      document.createElement(
        'div'
      );


    wrapper.className =
      WRAPPER_CLASS;


    wrapper.setAttribute(
      'data-jf-store-reviews-integrated',
      ''
    );


    wrapper.innerHTML =
      '<div class="jf-store-reviews-integrated__inner">' +

        '<div class="jf-store-reviews-integrated__title">' +
          'Det siger kunderne' +
        '</div>' +

        '<div class="jf-store-reviews-integrated__widget"></div>' +

      '</div>';


    return wrapper;
  }


  /* =======================================================
   * INSERT DIRECTLY AFTER ABOUT BLOCK
   * ======================================================= */

  function ensureWrapper() {
    var brand =
      findBrandBlock();


    if (!brand) {
      return null;
    }


    var wrapper =
      document.querySelector(
        '[data-jf-store-reviews-integrated]'
      );


    if (!wrapper) {
      wrapper =
        createWrapper();
    }


    if (
      brand.nextElementSibling !==
      wrapper
    ) {
      brand.insertAdjacentElement(
        'afterend',
        wrapper
      );
    }


    return wrapper;
  }


  /* =======================================================
   * MOVE JUDGE.ME WIDGET
   * ======================================================= */

  function moveWidget(
    widget,
    wrapper
  ) {
    if (
      !widget ||
      !wrapper
    ) {
      return;
    }


    var target =
      wrapper.querySelector(
        '.jf-store-reviews-integrated__widget'
      );


    if (!target) {
      return;
    }


    if (
      target.contains(
        widget
      )
    ) {
      return;
    }


    var originalSection =
      widget.closest(
        '[id^="shopify-section-"]'
      );


    target.appendChild(
      widget
    );


    widget.classList.add(
      'jf-store-reviews-widget'
    );


    if (
      originalSection &&
      !originalSection.contains(
        wrapper
      )
    ) {
      originalSection.classList.add(
        'jf-store-reviews-source-hidden'
      );
    }
  }


  /* =======================================================
   * CLEAN DEFAULT HEADINGS
   * ======================================================= */

  function cleanWidget(wrapper) {
    if (!wrapper) {
      return;
    }


    wrapper
      .querySelectorAll(
        'h1, h2, h3, h4, h5, h6'
      )
      .forEach(
        function (heading) {
          var text =
            normalize(
              heading.textContent
            );


          if (
            text === 'header' ||
            text === 'reviews' ||
            text === 'review snippets'
          ) {
            heading.style.setProperty(
              'display',
              'none',
              'important'
            );
          }
        }
      );
  }


  /* =======================================================
   * STYLES
   * ======================================================= */

  function installStyles() {
    if (
      document.getElementById(
        STYLE_ID
      )
    ) {
      return;
    }


    var style =
      document.createElement(
        'style'
      );


    style.id =
      STYLE_ID;


    style.textContent = `

      .jf-store-reviews-source-hidden {
        display:
          none !important;
      }


      /* ===================================================
       * OUTER AREA
       * =================================================== */

      .${WRAPPER_CLASS} {
        box-sizing:
          border-box;

        display:
          block;

        width:
          100%;

        margin:
          0;

        padding:
          0;

        background:
          #f3f1eb;

        color:
          #313333;
      }


      .${WRAPPER_CLASS}
      .jf-store-reviews-integrated__inner {
        box-sizing:
          border-box;

        width:
          min(100%, 960px);

        margin:
          0 auto;

        padding:
          10px 0 13px;
      }


      /* ===================================================
       * DIVIDER
       * =================================================== */

      .${WRAPPER_CLASS}
      .jf-store-reviews-integrated__inner::before {
        content:
          '';

        display:
          block;

        width:
          calc(100% - 28px);

        height:
          1px;

        margin:
          0 0 10px 14px;

        background:
          rgba(49, 51, 51, .11);
      }


      /* ===================================================
       * TITLE
       * =================================================== */

      .${WRAPPER_CLASS}
      .jf-store-reviews-integrated__title {
        margin:
          0 0 6px 14px;

        color:
          #313333;

        font-family:
          var(
            --heading-font-family,
            var(--text-font-family)
          );

        font-size:
          17px;

        font-weight:
          400;

        font-style:
          var(
            --heading-font-style,
            normal
          );

        line-height:
          1.2;

        letter-spacing:
          var(
            --heading-letter-spacing,
            0
          );

        text-transform:
          none;

        font-synthesis:
          none;
      }


      /* ===================================================
       * REVIEW WIDGET AREA
       * =================================================== */

      .${WRAPPER_CLASS}
      .jf-store-reviews-integrated__widget {
        box-sizing:
          border-box;

        width:
          calc(100% - 28px);

        min-width:
          0;

        margin:
          0 14px;

        padding:
          0 8px;
      }


      .${WRAPPER_CLASS}
      .jf-store-reviews-widget {
        display:
          block !important;

        position:
          static !important;

        width:
          100% !important;

        max-width:
          none !important;

        min-height:
          0 !important;

        height:
          auto !important;

        margin:
          0 !important;

        padding:
          0 !important;

        background:
          transparent !important;

        background-color:
          transparent !important;

        border:
          0 !important;

        box-shadow:
          none !important;

        overflow:
          visible !important;
      }


      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      > * {
        width:
          100% !important;

        max-width:
          none !important;

        margin:
          0 !important;
      }


      /* ===================================================
       * JUDGE.ME V2 CONTAINER
       * =================================================== */

      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-widget-v2__inner,

      .${WRAPPER_CLASS}
      .jm-carousel,

      .${WRAPPER_CLASS}
      .jm-carousel__viewport,

      .${WRAPPER_CLASS}
      .jm-carousel__track {
        width:
          100% !important;

        max-width:
          none !important;

        min-height:
          0 !important;

        background:
          transparent !important;

        box-shadow:
          none !important;
      }


      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-card {
        background:
          transparent !important;

        border:
          0 !important;

        border-radius:
          0 !important;

        box-shadow:
          none !important;

        min-height:
          0 !important;

        height:
          auto !important;
      }


      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-card__content {
        min-width:
          0 !important;

        width:
          100% !important;

        background:
          transparent !important;

        box-shadow:
          none !important;
      }


      /* ===================================================
       * TYPOGRAPHY
       * =================================================== */

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget,

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget p,

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget span:not([class*="star" i]),

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget div:not([class*="star" i]),

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget button:not([class*="star" i]) {
        font-family:
          var(--text-font-family) !important;
      }


      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-card__body {
        color:
          #313333 !important;

        font-family:
          var(--text-font-family) !important;

        font-size:
          var(--text-base) !important;

        font-weight:
          400 !important;

        line-height:
          1.38 !important;

        letter-spacing:
          var(
            --text-letter-spacing,
            .005em
          ) !important;
      }


      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-card__product {
        margin-top:
          4px !important;

        color:
          #313333 !important;

        opacity:
          .42;

        font-family:
          var(--text-font-family) !important;

        font-size:
          10px !important;

        font-weight:
          400 !important;

        line-height:
          1.2 !important;
      }


      /* ===================================================
       * STARS
       * =================================================== */

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      [class*="star"],

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      [aria-label*="star" i],

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      [aria-label*="rating" i] {
        color:
          #111111 !important;
      }


      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      [class*="star"] svg,

      .${WRAPPER_CLASS}
      .jf-store-reviews-widget
      [class*="star"] svg path {
        fill:
          #111111 !important;

        color:
          #111111 !important;
      }


      /* ===================================================
       * ARROWS
       * =================================================== */

      .${WRAPPER_CLASS}
      .jdgm-rev-snippet-widget-v2__arrow {
        background:
          transparent !important;

        background-color:
          transparent !important;

        border:
          0 !important;

        box-shadow:
          none !important;

        color:
          #313333 !important;

        opacity:
          .28;
      }


      /* ===================================================
       * TABLET
       * =================================================== */

      @media screen and (max-width: 999px) {

        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__inner {
          width:
            calc(100% - 40px);
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__inner::before {
          width:
            calc(100% - 20px);

          margin-left:
            10px;
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__title {
          margin-left:
            10px;
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__widget {
          width:
            calc(100% - 20px);

          margin:
            0 10px;

          padding:
            0 6px;
        }

      }


      /* ===================================================
       * MOBILE - EXACT JUDGE.ME V2 FIX
       * =================================================== */

      @media screen and (max-width: 749px) {

        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__inner {
          width:
            calc(100% - 20px);

          padding:
            10px 0 13px;
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__inner::before {
          width:
            100%;

          margin:
            0 0 9px;
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__title {
          margin:
            0 0 8px;

          font-size:
            16px;

          line-height:
            1.2;
        }


        /*
         * Give Judge.me virtually the full width.
         */
        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__widget {
          width:
            100%;

          margin:
            0;

          padding:
            0;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-widget-v2__inner {
          --jdgm-snippet-max-width:
            100% !important;

          width:
            100% !important;

          max-width:
            100% !important;
        }


        .${WRAPPER_CLASS}
        .jm-carousel,

        .${WRAPPER_CLASS}
        .jm-carousel__viewport,

        .${WRAPPER_CLASS}
        .jm-carousel__track {
          width:
            100% !important;

          max-width:
            none !important;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card {
          box-sizing:
            border-box;

          width:
            100% !important;

          max-width:
            none !important;

          padding:
            0 26px !important;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__content {
          display:
            block !important;

          width:
            100% !important;

          min-width:
            0 !important;

          padding:
            0 !important;
        }


        /*
         * Important mobile fix:
         * Judge.me's header should not stack each tiny
         * reviewer element on its own line.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header {
          display:
            flex !important;

          align-items:
            center !important;

          align-content:
            center !important;

          flex-wrap:
            nowrap !important;

          width:
            100% !important;

          min-width:
            0 !important;

          gap:
            5px !important;

          margin:
            0 0 5px !important;

          padding:
            0 !important;

          white-space:
            nowrap;
        }


        /*
         * Do not allow individual header children
         * to become full-width rows.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        > * {
          width:
            auto !important;

          max-width:
            none !important;

          min-width:
            0 !important;

          flex:
            0 0 auto !important;

          margin:
            0 !important;
        }


        /*
         * Reviewer name may shrink if necessary,
         * but stays beside the verification badge.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="name"],

        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="reviewer"],

        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="author"] {
          width:
            auto !important;

          max-width:
            150px !important;

          overflow:
            hidden;

          text-overflow:
            ellipsis;

          white-space:
            nowrap;

          font-weight:
            500 !important;
        }


        /*
         * Stars remain compact.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="star"] {
          flex:
            0 0 auto !important;

          font-size:
            16px !important;

          line-height:
            1 !important;
        }


        /*
         * Review body uses the full width below header.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__body {
          display:
            block !important;

          width:
            100% !important;

          max-width:
            none !important;

          margin:
            0 !important;

          padding:
            0 !important;

          font-size:
            var(--text-base) !important;

          line-height:
            1.4 !important;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__product {
          display:
            block !important;

          width:
            100% !important;

          margin:
            5px 0 0 !important;

          padding:
            0 !important;

          font-size:
            9px !important;

          opacity:
            .40;
        }


        /*
         * Arrows remain easy to tap,
         * but visually quiet.
         */
        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-widget-v2__arrow {
          width:
            30px !important;

          min-width:
            30px !important;

          height:
            40px !important;

          opacity:
            .40;
        }

      }


      /* ===================================================
       * SMALL MOBILE
       * =================================================== */

      @media screen and (max-width: 389px) {

        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__inner {
          width:
            calc(100% - 16px);
        }


        .${WRAPPER_CLASS}
        .jf-store-reviews-integrated__title {
          font-size:
            15px;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card {
          padding:
            0 22px !important;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header {
          gap:
            4px !important;
        }


        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="name"],

        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="reviewer"],

        .${WRAPPER_CLASS}
        .jdgm-rev-snippet-card__header
        [class*="author"] {
          max-width:
            125px !important;
        }

      }

    `;


    document.head.appendChild(
      style
    );
  }


  /* =======================================================
   * SETUP
   * ======================================================= */

  function setup() {
    installStyles();


    var widget =
      findStoreWidget();


    if (!widget) {
      return;
    }


    var wrapper =
      ensureWrapper();


    if (!wrapper) {
      return;
    }


    moveWidget(
      widget,
      wrapper
    );


    cleanWidget(
      wrapper
    );


    /*
     * Keep it directly after "Om Justfishing".
     */
    var brand =
      findBrandBlock();


    if (
      brand &&
      brand.nextElementSibling !==
        wrapper
    ) {
      brand.insertAdjacentElement(
        'afterend',
        wrapper
      );
    }
  }


  /* =======================================================
   * OBSERVER
   * ======================================================= */

  function scheduleSetup() {
    if (scheduled) {
      return;
    }


    scheduled =
      true;


    requestAnimationFrame(
      function () {
        scheduled =
          false;

        setup();
      }
    );
  }


  function init() {
    installStyles();

    setup();


    new MutationObserver(
      scheduleSetup
    ).observe(
      document.body,
      {
        childList:
          true,
        subtree:
          true
      }
    );


    [
      100,
      250,
      500,
      800,
      1200,
      1800,
      2500,
      4000,
      6000
    ].forEach(
      function (delay) {
        setTimeout(
          setup,
          delay
        );
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

})();

/* === END: STORE REVIEWS INTEGRATED UNDER ABOUT === */